import * as React from 'react';
import { IgcTreeComponent as Component } from 'igniteui-webcomponents';
import type { IgcTreeComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * The tree allows users to represent hierarchical data in a tree-view structure,
 * maintaining parent-child relationships, as well as to define static tree-view structure without a corresponding data model.
 * @slot  - Renders the tree items inside default slot.
 * @fires igcSelection - Emitted when item selection is changing, before the selection completes.
 * @fires igcItemCollapsed - Emitted when tree item is collapsed.
 * @fires igcItemCollapsing - Emitted when tree item is about to collapse.
 * @fires igcItemExpanded - Emitted when tree item is expanded.
 * @fires igcItemExpanding - Emitted when tree item is about to expand.
 * @fires igcActiveItem - Emitted when the tree's `active` item changes.
 * @class
 */
export const IgrTree = /* @__PURE__ */ createComponent({
  tagName: 'igc-tree',
  displayName: 'IgrTree',
  elementClass: Component,
  react: React,
  events: {
    onSelection: 'igcSelection' as EventName<
      IgcTreeComponentEventMap['igcSelection']
    >,
    onItemCollapsed: 'igcItemCollapsed' as EventName<
      IgcTreeComponentEventMap['igcItemCollapsed']
    >,
    onItemCollapsing: 'igcItemCollapsing' as EventName<
      IgcTreeComponentEventMap['igcItemCollapsing']
    >,
    onItemExpanded: 'igcItemExpanded' as EventName<
      IgcTreeComponentEventMap['igcItemExpanded']
    >,
    onItemExpanding: 'igcItemExpanding' as EventName<
      IgcTreeComponentEventMap['igcItemExpanding']
    >,
    onActiveItem: 'igcActiveItem' as EventName<
      IgcTreeComponentEventMap['igcActiveItem']
    >,
  },
});

export type IgrTree = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrTreeModule = Component;
